module.exports = __webpack_public_path__ + "static/img/dance_revolution_port_lg.fd181f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/ddr-banner-campaign/dance_revolution_port_lg.jpg
// module id = 232
// module chunks = 2